export enum NewsAudienceEnum {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ALL = "ALL",
  CAC = "CAC",
  COLLAB = "COLLAB",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  BROADCAST_LIST = "BROADCAST_LIST"
}

export const NEWS_AUDIENCES = [
  {
    value: NewsAudienceEnum.ALL,
    label: "add_news.audience.labels.ALL"
  },
  {
    value: NewsAudienceEnum.CAC,
    label: "add_news.audience.labels.CAC"
  },
  {
    value: NewsAudienceEnum.COLLAB,
    label: "add_news.audience.labels.COLLAB"
  },
  {
    value: NewsAudienceEnum.BROADCAST_LIST,
    label: "add_news.audience.labels.BROADCAST_LIST"
  }
] as { value: string; label: string }[];
